import React, { useEffect, useState } from "react";
import { Table, Image, Modal, Select, Button, message } from "antd";
// import { useCustomerList } from '../../../api/customer';
import {
  useAddVCEOrder,
  useGetVCEByOrderId,
  useRemoveVCEOrder,
} from "../../../api/order";
import TableAction from "../../TableAction";
import { useGetUsersListByRole } from "../../../api/profile";
import { AuthContextValue, useAuth } from "../../../providers/AuthProvider";
// import { useGetUsersListByRole } from '../../../api/profile';

type vceTableProps = {
  orderId: string;
};

const VCETable: React.FC<vceTableProps> = ({ orderId }) => {
  const { user } = useAuth() as AuthContextValue;
  const { data: vces, isLoading, refetch } = useGetVCEByOrderId(orderId);
  const [profiles, setProfiles] = useState<any>();
  const [userId, setUserId] = useState<number | undefined>();

  const { data: users } = useGetUsersListByRole("MOB_ROLE_BUYER_AGENT");
  const { mutateAsync: assignVCE, isPending } = useAddVCEOrder();
  const { mutateAsync: removeVCE, isPending: removing } = useRemoveVCEOrder();

  const [searchText, setSearchText] = useState<string>("");
  const [selectedId, setSelectedId] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [removeopen, setRemoveOpen] = useState(false);

  const handleCreate = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (vces && vces.data.data.length > 0) {
      setProfiles(vces.data.data);
    }
  }, [vces]);

  const onSubmit = async () => {
    if (userId && !isNaN(Number(orderId))) {
      const result = await assignVCE({ orderId: Number(orderId), userId });
      refetch();
      setOpen(false);
    }
  };

  const onRemove = async () => {
    if (selectedId) {
      try {
        const result = await removeVCE(Number(selectedId));
        if (result.status === 2000) {
          message.success("Value-chain-executor removed successfully.");
        }
      } catch (err: any) {
        message.error("operation failed");
      } finally {
        refetch();
        setRemoveOpen(false);
      }
    }
  };

  const vceColumn = [
    {
      title: "No.",
      width: 60,
      render: (text: string, record: any, index: number) => <b>#{index + 1}</b>,
    },
    {
      dataIndex: "fullName",
      title: "Full name",
      render: (text: string, record: any) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontWeight: 400,
              fontSize: 15,
              gap: 12,
            }}
          >
            {/* <Image src={record.avatar_url} style={{ width: 30, aspectRatio: 1, borderRadius: 50 }} /> */}
            {record.fullName}
          </div>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone number",
      dataIndex: "phoneNumber",
    },
    {
      title: "Action",
      dataIndex: "id",
      render: (id: number) => {
        return (
          <Button
            onClick={() => {
              setSelectedId(id.toString());
              setRemoveOpen(true);
            }}
          >
            Remove
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        open={removeopen}
        title={<div className="text-black">Remove</div>}
        onOk={onRemove}
        onCancel={() => setRemoveOpen(false)}
        okButtonProps={{
          disabled: removing,
          loading: removing,
        }}
      >
        <div className="text-black">
          Are you sure you want to remove the selected value-chain-executer from
          this order?
        </div>
      </Modal>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 600,
              fontSize: 27.43,
              color: "black",
            }}
          >
            Select value chain executor
          </div>
        }
        destroyOnClose={true}
        open={open}
        centered
        okButtonProps={{
          disabled: userId === undefined || isPending,
          loading: isPending,
        }}
        onOk={onSubmit}
        onCancel={hideModal}
        closable
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Select
            value={userId}
            placeholder="Select value chain executor"
            style={{ width: "100%" }}
            onChange={(val: any) => setUserId(val)}
            options={users?.data?.data?.map((user: any) => {
              return { label: user.fullName, value: user.vceId };
            })}
          />
        </div>
      </Modal>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: 80,
          backgroundColor: "#EEF3F8",
          borderRadius: 8.4,
          marginBottom: 12,
        }}
      >
        <TableAction
          setSearchText={setSearchText}
          onCreateNew={
            user?.roleName === "ROLE_KFT_SP_ADMIN" ? handleCreate : undefined
          }
        />
      </div>
      <Table
        style={{
          cursor: "pointer",
          position: "relative",
          zIndex: 100,
          overflowY: "hidden",
        }}
        scroll={{ y: 600 }}
        dataSource={profiles || []}
        columns={vceColumn}
        loading={false}
      />
    </>
  );
};

export default VCETable;
